import { render, staticRenderFns } from "./ValidatedTransactions.vue?vue&type=template&id=04fcab5a&"
import script from "./ValidatedTransactions.vue?vue&type=script&lang=js&"
export * from "./ValidatedTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports